// extracted by mini-css-extract-plugin
module.exports = {"boxLoading":"_2Z803RANGmfBKT3duh-pTW","boxNotImg":"_1ksnt8z1Vhjs2_xkZMHCEI","typeIcon":"_3FUjxfNF4WeynW3yPmtyDM","boxIcon":"_2dFMP8YmWUUjlvjqqMYVPX"};